import { render, staticRenderFns } from "./WeekDetails.vue?vue&type=template&id=0f7d523b&"
import script from "./WeekDetails.vue?vue&type=script&lang=js&"
export * from "./WeekDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports